import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import { ChevronLeftIcon } from '@heroicons/react/outline';
import { usePersistState } from 'helper';
// import ThumbIcon from 'partial/components/ThumbIcon';

function SideList({ id, children, renderList }) {
  const location = useLocation();
  const [selected, setSelected] = usePersistState(
    id,
    location?.state?.selected,
    { keepOnUnmount: false }
  );
  const handleClearSelected = (e) => {
    e.preventDefault();
    setSelected(null);
  };
  const hasSelected = !!selected;
  return (
    <div className="flex-1 relative z-0 flex overflow-hidden">
      <main
        className={cn(
          'flex-1 relative z-0 overflow-y-scroll focus:outline-none xl:order-last py-5 pr-5',
          hasSelected ? 'block' : 'hidden xl:block'
        )}
      >
        <nav
          className="bg-white flex items-start px-4 py-5 md:py-3 sm:px-6 lg:px-8 xl:hidden"
          aria-label="Breadcrumb"
        >
          <a
            href="/"
            className="inline-flex items-center space-x-3 text-sm font-medium text-gray-900"
            onClick={handleClearSelected}
          >
            <ChevronLeftIcon
              className="-ml-2 h-5 w-5 text-gray-400"
              aria-hidden="true"
            />
            <span>Back to List</span>
          </a>
        </nav>
        {children}
      </main>
      <aside
        className={cn(
          'xl:order-first xl:flex xl:flex-col flex-shrink-0 xl:w-80 p-5 border-gray-200',
          hasSelected ? 'hidden' : 'flex w-full min-h-full flex-col'
        )}
      >
        {renderList(selected, setSelected)}
      </aside>
      {/* <aside
        className={cn(
          'xl:order-first xl:flex xl:flex-col flex-shrink-0 border-r border-gray-200 bg-gray-300 rounded-r-lg',
          hasSelected ? 'hidden' : 'flex w-full min-h-full flex-col'
        )}
      >
        <ul className="space-y-2 p-1">
          <li>
          <ThumbIcon
            className="h-10 w-10 rounded-lg"
          />
          </li>
          <li>
          <ThumbIcon
            className="h-10 w-10 rounded-lg"
          />
          </li>
          <li>
          <ThumbIcon
            className="h-10 w-10 rounded-lg"
          />
          </li>
          <li>
          <ThumbIcon
            className="h-10 w-10 rounded-lg"
          />
          </li>
        </ul>
      </aside> */}
    </div>
  );
}

SideList.propTypes = {
  id: PropTypes.string.isRequired,
  renderList: PropTypes.oneOfType([
    PropTypes.instanceOf(Object),
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
  children: PropTypes.oneOfType([
    PropTypes.instanceOf(Object),
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
};

export default SideList;
